
import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';

const requireContext = require.context('@/assets/img', true, /.+-component\.svg$/);
const suffix = 'Svg';

const components = requireContext.keys().map(item => {
  const name = item.replace(/^.+\/(.+)-component.svg$/, '$1');
  const component = require('@/assets/img' + item.replace(/^\./, '') + '?inline');

  return [
    upperFirst(camelCase(name)) + suffix,
    component
  ];
});

export default components;
